import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

interface NavbarProps {
  city: string;
}

export function Navbar({ city }: NavbarProps) {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav className={`fixed w-full z-50 transition-all duration-300 ${isScrolled ? 'bg-white shadow-md' : 'bg-transparent'}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          <Link to="/" className="flex items-center space-x-2">
            <div className="w-10 h-10 flex items-center justify-center">
              <i className={`ri-window-line text-3xl ${isScrolled ? 'text-teal-600' : 'text-white'}`}></i>
            </div>
            <span className={`text-xl font-bold ${isScrolled ? 'text-gray-900' : 'text-white'}`}>
              FenetrePro {city}
            </span>
          </Link>
          
          <div className="hidden md:flex items-center space-x-8">
            <a href="#services" className={`text-sm font-medium hover:text-teal-600 transition-colors ${isScrolled ? 'text-gray-700' : 'text-white'}`}>
              Services
            </a>
            <a href="#baies-vitrees" className={`text-sm font-medium hover:text-teal-600 transition-colors ${isScrolled ? 'text-gray-700' : 'text-white'}`}>
              Baies Vitrées
            </a>
            <a href="#contact" className={`text-sm font-medium hover:text-teal-600 transition-colors ${isScrolled ? 'text-gray-700' : 'text-white'}`}>
              Contact
            </a>
            <a href="tel:+33554542545" className="bg-teal-600 text-white px-6 py-2.5 rounded-full text-sm font-medium hover:bg-teal-700 transition-colors whitespace-nowrap">
              05 54 54 25 45
            </a>
          </div>
        </div>
      </div>
    </nav>
  );
}